export const colors = {
  darkBlue: "#0a1628",
  anthracite: "#1a202c",
  accent: "#3b82f6",
  white: "#ffffff",
  gray: "#94a3b8",
};
